export type Basic = string | number | boolean | null | undefined;

export const BASIC_ROW_HEIGHT = 30;

export const isValueStringEmpty = (value: Basic): boolean => {
  if (typeof value === 'number' || typeof value === 'boolean') {
    return false;
  }
  return !value;
};
